export function prettyPrintEnum(value: string): string {
  return value
    .split('_')
    .map((s) => s.toLowerCase())
    .map((s) => `${s.substring(0, 1).toUpperCase()}${s.substring(1)}`)
    .join(' ');
}
